import React, { useEffect, useState } from "react";
import { Table, TableBody, TableCell, TableRow } from "@material-ui/core";
import moment from "moment";
import { FiAlertTriangle } from "react-icons/fi";
import Moment from "react-moment";
import LoadingGif from "../../assets/loading.gif";
import * as HomeService from "../../service/HomeService";
import { formatNumber } from "../../utils/NumberUtils";
import LoadingBar from "../LoadingBar/LoadingBar";

/**
 * @author Thiago Guimarães
 * @date 01/03/2021
 */
let countdownTimeOut = null;
const timeToRefresh = 5 * 60;

function Ir21Amount() {
  const [loading, setLoading] = useState(false);

  const [amountLastMonth, setAmountLastMonth] = useState("-");
  const [amountThisMonth, setAmountThisMonth] = useState("-");
  const [amountLastWeek, setAmountLastWeek] = useState("-");
  const [amountThisWeek, setAmountThisWeek] = useState("-");

  const [errors, setErrors] = useState("");

  const [time, setTime] = useState(timeToRefresh);
  const [lastUpdate, setLastUpdate] = useState(new Date());
  const [isActive, setIsActive] = useState(false);

  // Separa os minutos em duas unidades,colocando 0 no inicio quando necessario.
  const minuteLeftRight = String(Math.floor(time / 60))
    .padStart(2, "0")
    .split("");

  // Separa os segundos em duas unidades,colocando 0 no inicio quando necessario.
  const secondsLeftRight = String(time % 60)
    .padStart(2, "0")
    .split("");

  useEffect(() => {
    if (!isActive) {
      if (!loading) {
        setLoading(true);
        setErrors("");

        const firstDayLastMonth = moment().subtract(1, "months").startOf("month").toISOString();
        const lastDayLastMonth = moment().subtract(1, "months").endOf("month").toISOString();

        const firstDayLastWeek = moment().subtract(1, "weeks").startOf("week").toISOString();
        const lastDayLastWeek = moment().subtract(1, "weeks").endOf("week").toISOString();

        const firstDayThisMonth = moment().startOf("month").toISOString();
        const firstDayThisWeek = moment().startOf("week").toISOString();

        const lastMonth = HomeService.getAmountUpdatedIr21(firstDayLastMonth, lastDayLastMonth);
        const thisMonth = HomeService.getAmountUpdatedIr21(firstDayThisMonth);
        const lastWeek = HomeService.getAmountUpdatedIr21(firstDayLastWeek, lastDayLastWeek);
        const thisWeek = HomeService.getAmountUpdatedIr21(firstDayThisWeek);

        Promise.all([lastMonth, thisMonth, lastWeek, thisWeek])
          .then((values) => {
            setAmountLastMonth(values[0]);
            setAmountThisMonth(values[1]);
            setAmountLastWeek(values[2]);
            setAmountThisWeek(values[3]);
          })
          .catch(() => setErrors("Something went wrong. Try again!!"))
          .finally(() => {
            clearTimeout(countdownTimeOut);
            setIsActive(true);
            setTime(timeToRefresh);
            setLastUpdate(new Date());
            setLoading(false);
          });
      }
    } else if (isActive && time > 0) {
      countdownTimeOut = setTimeout(() => {
        setTime(time - 1);
      }, 1000);
    } else if (isActive && time === 0 && !loading) {
      setIsActive(false);
    }

    return () => {
      clearTimeout(countdownTimeOut);
    };
  }, [isActive, time]); // eslint-disable-line

  return (
    <div className="col">
      <div className="ibox">
        <div className="ibox-title d-flex flex-column">
          <h5 className="mb-1">IR.21 Updates</h5>
          <span className="text-muted" style={{ fontSize: "60%" }}>
            Last Update: <Moment format="DD/MM/yyyy HH:mm:ss">{lastUpdate}</Moment>
          </span>
        </div>
        <div className="ibox-content">
          {errors ? (
            <div className="text-center">
              <span className="text-danger">
                <FiAlertTriangle size="30" /> {errors}
              </span>
            </div>
          ) : (
            <div className="text-center">
              {loading ? (
                <img src={LoadingGif} width="40px" alt="Loading" />
              ) : (
                <>
                  <Table>
                    <TableBody>
                      <TableRow>
                        <TableCell>Last Month</TableCell>
                        <TableCell  className="text-right">{formatNumber(amountLastMonth)}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>This Month</TableCell>
                        <TableCell  className="text-right">{formatNumber(amountThisMonth)}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>Last Week</TableCell>
                        <TableCell  className="text-right">{formatNumber(amountLastWeek)}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>This Week</TableCell>
                        <TableCell  className="text-right">{formatNumber(amountThisWeek)}</TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </>
              )}
            </div>
          )}
          <div className="text-center mt-3">
            <small>
              <span onClick={() => setTime(0)} className="" style={{ cursor: "pointer" }}>
                <small>
                  Refresh ({`${minuteLeftRight[0]}${minuteLeftRight[1]}:${secondsLeftRight[0]}${secondsLeftRight[1]}`})
                </small>
              </span>
            </small>
          </div>
          <LoadingBar percent={(time * 100) / timeToRefresh} />
        </div>
      </div>
    </div>
  );
}

export default Ir21Amount;
